import { render, staticRenderFns } from "./SubjectCard.vue?vue&type=template&id=3261761e&"
import script from "./SubjectCard.vue?vue&type=script&lang=js&"
export * from "./SubjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports